import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaUserPlus, FaArrowLeft, FaPhone, FaBan, FaCheck, FaInfoCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

export default function Clientes() {
    const navigate = useNavigate();
    const [clientes, setClientes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [form, setForm] = useState({ nombre: '', telefono: '' });

    useEffect(() => { fetchClientes(); }, []);

    const fetchClientes = async () => {
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/clientes');
            setClientes(res.data);
        } catch (error) {
            console.error("Error cargando clientes:", error);
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        try {
            // Nota: El backend debe estar preparado para recibir sucursal_registro_id si lo deseas
            await axios.post('https://api.alquilacarbolivia.com/api/clientes', form);
            Swal.fire('Registrado', 'Cliente agregado correctamente', 'success');
            setShowModal(false);
            setForm({ nombre: '', telefono: '' });
            fetchClientes();
        } catch (error) {
            Swal.fire('Error', 'No se pudo registrar', 'error');
        }
    };

    const handleBloqueo = async (cli, nuevoEstado) => {
        let motivo = '';
        if (nuevoEstado === 'bloqueado') {
            const { value } = await Swal.fire({ 
                title: 'Bloquear Cliente', 
                input: 'text', 
                inputLabel: 'Motivo del bloqueo (Aparecerá al intentar venderle)', 
                inputPlaceholder: 'Ej: No pagó renta anterior, conflictivo...',
                showCancelButton: true
            });
            if (value === undefined) return; // Si cancela
            motivo = value || 'Sin motivo especificado';
        }
        
        try {
            await axios.post('https://api.alquilacarbolivia.com/api/clientes/bloqueo', { 
                id: cli.id, 
                estado: nuevoEstado, 
                motivo 
            });
            Swal.fire('Éxito', `Cliente ${nuevoEstado === 'bloqueado' ? 'bloqueado' : 'desbloqueado'}`, 'success');
            fetchClientes();
        } catch (error) {
            Swal.fire('Error', 'No se pudo cambiar el estado', 'error');
        }
    };

    return (
        <div className="container mt-4 pb-5">
            <button className="btn btn-secondary mb-3 shadow-sm" onClick={() => navigate('/admin')}>
                <FaArrowLeft/> Volver
            </button>
            
            <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm">
                <h2 className="m-0 fw-bold text-dark">Directorio de Clientes</h2>
                <button className="btn btn-success fw-bold px-4 shadow-sm" onClick={() => setShowModal(true)}>
                    <FaUserPlus className="me-2"/> Nuevo Cliente
                </button>
            </div>

            <div className="card shadow border-0 overflow-hidden">
                <table className="table table-hover align-middle mb-0">
                    <thead className="bg-dark text-white">
                        <tr>
                            <th className="ps-4">Nombre Completo</th>
                            <th>Contacto</th>
                            <th>Origen Registro</th>
                            <th>Estado</th>
                            <th className="text-center">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        {clientes.map(cli => (
                            <tr key={cli.id} className={cli.estado === 'bloqueado' ? 'table-danger' : ''}>
                                <td className="ps-4">
                                    <div className="fw-bold text-dark">{cli.nombre}</div>
                                    <small className="text-muted">ID: #{cli.id}</small>
                                </td>
                                <td>
                                    <FaPhone className="text-secondary me-2 small"/> 
                                    {cli.telefono || 'Sin número'}
                                </td>
                                <td>
                                    <span className="badge bg-secondary text-uppercase px-2 py-1" style={{fontSize: '0.7rem'}}>
                                        {cli.sucursal_origen || 'SISTEMA'}
                                    </span>
                                </td>
                                <td>
                                    {cli.estado === 'bloqueado' ? (
                                        <div>
                                            <span className="badge bg-danger">BLOQUEADO</span>
                                            <div className="text-danger x-small mt-1" style={{fontSize:'0.75rem'}}>
                                                <FaInfoCircle className="me-1"/> {cli.motivo_bloqueo}
                                            </div>
                                        </div>
                                    ) : (
                                        <span className="badge bg-success">ACTIVO</span>
                                    )}
                                </td>
                                <td className="text-center">
                                    {cli.estado === 'bloqueado' ? (
                                        <button className="btn btn-success btn-sm fw-bold px-3" onClick={() => handleBloqueo(cli, 'activo')}>
                                            <FaCheck className="me-1"/> Desbloquear
                                        </button>
                                    ) : (
                                        <button className="btn btn-outline-danger btn-sm fw-bold px-3" onClick={() => handleBloqueo(cli, 'bloqueado')}>
                                            <FaBan className="me-1"/> Bloquear
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                        {clientes.length === 0 && (
                            <tr><td colSpan="5" className="text-center p-5 text-muted">No hay clientes registrados.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div className="modal d-block" style={{backgroundColor:'rgba(0,0,0,0.5)'}}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg">
                            <div className="modal-header bg-success text-white">
                                <h5 className="modal-title fw-bold">Registrar Nuevo Cliente</h5>
                                <button className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
                            </div>
                            <form onSubmit={handleSave}>
                                <div className="modal-body p-4">
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Nombre Completo *</label>
                                        <input type="text" className="form-control" required 
                                            value={form.nombre} onChange={e => setForm({...form, nombre: e.target.value})} 
                                            placeholder="Ej: Juan Perez" autoFocus />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label fw-bold">Teléfono de Contacto</label>
                                        <input type="number" className="form-control" 
                                            value={form.telefono} onChange={e => setForm({...form, telefono: e.target.value})} 
                                            placeholder="Ej: 77712345" />
                                    </div>
                                </div>
                                <div className="modal-footer bg-light">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
                                    <button type="submit" className="btn btn-success fw-bold px-4">Guardar Cliente</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}